export default "__VITE_ASSET__ec56d6a8__"